module.exports = __webpack_public_path__ + "static/media/instagram-black-white.c0b5446e.svg";